var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sanitasToolTip"},[_c('dotcom-tooltip',{attrs:{"content":_vm.content,"is-text-link":false}}),_c('p',{staticClass:"sanitasToolTip-title"},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }